module.exports = {"notification.message":"Wix.com faz uso de cookies para lhe oferecer a melhor experiência possível.","notification.got.it":"Entendi","notification.more.info":"Saiba mais","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_pt.json
// module id = 55
// module chunks = 0